// Apryse WebViewer Portfolio tests

import React, { useRef, useEffect } from 'react';

import Box from '@mui/material/Box';
import WebViewer from '@pdftron/webviewer';
import { uxLicense } from './webviewer_license';
import { MessageHooks } from "../App";
import { UserInfo, netGet, netFetch, keycloak, getAuthHeaders } from "./network";
import {getChannel} from 'postal';
import './webviewer.css';

// last component is Uniscope's version
// change also the setupProxy.js to match version
const viewerVersion = '10.5.1.1'; 
const postal = getChannel('ucs');
var portfolioInstance;
var initializing = false;
var firstInstance = true;
var multiviewerEnabled = false;
var changingVersions = false;
var currentDocument = 'DUMMY';

const initPortfolio = () => {
    if (initializing) {
        return;
    }
    if (portfolioInstance) {
        return;
    }
    console.log('Initializing portfolio...');
    initializing = true;
    // sessionId most probably won't be ready at this time
    // console.log('My sessionId ' + UserInfo.info.sessionId);
    let container = document.getElementById('portfolio-viewer-container');
    container.innerHTML = '';
    let viewer = document.createElement('div');
    viewer.id = 'portfolio-viewer';
    viewer.classList.add('webviewer');
    container.appendChild(viewer);

    const webviewerPath = "/webviewer-" + viewerVersion;
    console.log('Opening webviewer portfolio at ' + webviewerPath);

    // and don't load any initial document 
    WebViewer (
        {
            /* licenseKey: uxLicense, */
            path: webviewerPath,
            enableAnnotations: true,
            fullAPI: true,
            disabledElements: ['annotationNoteConnectorLine'],
            enableAnnotationNumbering: true,
        },
        // document.getElementById('portfolio-viewer'),
        viewer,
    ).then((instance) => {

        console.log('On Portfolio...');
        // instance set here, it gets exported
        // should we use React's shared state instead
        portfolioInstance = instance;

        // instance.UI.enableNativeScrolling();
        instance.UI.enableFeatures([instance.UI.Feature.Portfolio]);

        instance.UI.disableElements(['toolbarGroup-Shapes', 'toolbarGroup-Edit', 'toolbarGroup-Insert']);
        // instance.UI.disableElements(['downloadButton', 'printButton', 'saveAsButton']);

        const { documentViewer, annotationManager, Annotations, Tools } = instance.Core;

        if (firstInstance) {

            

            

        }
        firstInstance = false;
        


        documentViewer.addEventListener('documentLoaded', () => {

            
            
            // load the annotation data
            // document load was triggered by user so UserInfo should be set by now
            let auth = getAuthHeaders();
            netFetch('/api/webviewer/xfdf/' + UserInfo.info.sessionId + '?doc=' + currentDocument, {
                method: 'GET',
                headers: auth,
            })
                .then(response => {

                    response.text().then(xfdfString => {
                        // <xfdf><annots><text subject="Comment" page="0" color="#FFE6A2" ... /></annots></xfdf>
                        annotationManager.importAnnotations(xfdfString);
                    });

                });
        });

        documentViewer.addEventListener('documentUnloaded', () => {
            instance.UI.disableFeatures([instance.UI.Feature.MultiViewerMode]);
            multiviewerEnabled = false;
            changingVersions = false;
            closePdfViewer();
        });

        annotationManager.addEventListener('annotationChanged', function (a, b, e) {
            // If the event is triggered by importing then it can be ignored
            // This will happen when importing the initial annotations from the server or individual changes from other users
            if ( e.info && e.info.imported ) return;
            if (e.imported) return;

            annotationManager.exportAnnotationCommand().then(xfdfString => {
                // <xfdf>
                //    <add>
                //      <text subject="Comment" page="0" color="#FFE6A2" ... />
                //    </add>
                //    <modify />
                //    <delete />
                // </xfdf>
                const auth = getAuthHeaders();
                let myHeaders = { 'Content-Type': 'text/xml;charset=UTF-8', ...auth };
                // console.log('Annot update: ' + currentDocument + ' => ' + currentDocumentLabel);
                netFetch('/api/webviewer/annots/update/' + UserInfo.info.sessionId + '?doc=' + currentDocument, {
                    method: 'POST',
                    body: xfdfString,
                    headers: myHeaders,
                });
            });
        });

        postal.publish(
            "portfolio.initialized",
            {
                instance: instance
            }
        );

        initializing = false;
    }).catch(error => {
        console.log('Error initializing Portfolio Webviewer: ' + error);
        initializing = false;
    });
}

const closePdfViewer = () => {
    /*
    // this should close the document as well
    // since we're listening to the page index change to do so
    postal.publish({
        topic: "app.page.change.index",
        data: {
            index: 0
        }
    });
    */
};

const PortfolioWebViewer = (props) => {
    const viewer = useRef(null);

    
    React.useEffect(() => {

        initPortfolio();

        const unsubscribe = postal.subscribe(
            "portfolio.initialized",
            (envelope) => {
                // console.log('Got message: ' + JSON.stringify(data) + ',' + JSON.stringify(envelope));
                handlePostalWebviewerInitialized(envelope.payload);
            }
        );

        return () => {
            unsubscribe();
        }

    }, []);

    

    const removeViewer = () => {
        
    };

    const handlePostalWebviewerInitialized = (msg) => {
        /*
        if (scheduledDocument.length > 0) {
            const job = scheduledDocument.pop();
            if (job) {
                if ( job.readOnly ) {
                    viewPdfDocument(job.path, job.label);
                } else {
                    loadPdfDocument(job.path, job.label, job.previousDrafts);
                }
            }
        }
        */
    }


    const annotMessage = (message) => {
        /*
        let wevent = message.data;
        // console.log('Received collab message: ' + JSON.stringify(wevent));
        const msg = wevent.data;
        if (pdftronInstance) {
            if (msg) {
                if (msg.docPath ) {
                    if ( msg.docPath === currentDocument ) {
                        processAnnotations(msg);
                    } else {
                        console.log('Skipping annotations for different document ' + msg.docPath);
                    }
                    
                } else {
                    console.log('No target document in annotation message, processing anyway...');
                    processAnnotations(msg);
                }
            }
        }
        */
    };

    const processAnnotations = (msg) => {
        const { annotationManager } = portfolioInstance.Core;

        if (msg.add) {
            annotationManager.importAnnotationCommand(msg.add).then(function (annotations) {
                annotations.forEach(function (item, index) {
                    annotationManager.redrawAnnotation(item);
                });
            });

        }
        if (msg.modify) {
            annotationManager.importAnnotationCommand(msg.modify).then(function (annotations) {
                annotations.forEach(function (item, index) {
                    annotationManager.redrawAnnotation(item);
                });
            });
        }
        if (msg.remove) {
            annotationManager.importAnnotationCommand(msg.remove);
        }
    };

    MessageHooks["collab"]["webviewer"] = annotMessage;

    

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100%', zIndex: 100 }}>
            { /* <div id="pdftron-viewer" className="webviewer" ref={viewer}></div> */ }
            <div id="portfolio-viewer-container" ref={viewer} style={{width: "100%", height: "100%"}}/>
        </Box>
    );


};

export { PortfolioWebViewer, portfolioInstance, initPortfolio };
